import React, { useCallback } from 'react'
import OderInfo from './indextwo'
import { Modal, Toast } from 'antd-mobile'
import style from './oderInfo.module.css'
import { useEffect, useState, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import Login from '../Login'
import { goodsauthtwo } from '../../utils/tooltwo'
import Detainment from '../Detainment/indextow'
import { PAY } from '../../utils/config'

export default function Mypopup(poprs) {
  let history = useLocation()
  const [countDown, setCountDown] = useState(1800)
  let [checked, setChecked] = useState(false) // 协议选择
  let [key, setKey] = useState(undefined) // 用户key
  let [member_id, setMember_id] = useState(undefined) // 用户id
  let [phoneNum, setPhoneNum] = useState(false) //是否登录过
  let [userPhone, setUserPhone] = useState('') //用户手机号
  let [goodsPrice, setGoodsPrice] = useState('')
  const [checkedPay, setCheckedPay] = useState(() => PAY.WX) // 支付选择
  const [modal2, setModal2] = useState(false)
  const [subFlag, setSubFlag] = useState(false)
  /**
   * 判断是否登录过，没登录获取用户信息，登录过直接调取支付
   */
  function getPhone() {
    return sessionStorage.getItem('member_id') ? true : false
  }
  // 存储用户信息
  function storagUsertUserInfo(info) {
    sessionStorage.setItem(info.name, info.value)
  }
  // 获取用户信息
  function getUserInfo(name) {
    return sessionStorage.getItem(name) || localStorage.getItem(name)
  }

  useEffect(() => {
    setGoodsPrice(() => (poprs.sku_id == 1 ? '8.8' : '8.8'))
  }, [poprs.sku_id, goodsPrice])
  useEffect(() => {
    let timer = null
    // 倒计时
    timer = setInterval(() => {
      setCountDown((countDown) => {
        return --countDown
      })
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [])
  useEffect(() => {
    let pathSearch = history.search.substring(1)
    pathSearch = pathSearch.split('=')
    if (pathSearch[0] === 'checked' && pathSearch[1] === 'true') {
      setChecked(pathSearch[1])
    }
  }, [setChecked, history.search])
  // 子组件方法
  const childRef = useRef()
  const loginRef = useRef()
  // const refLogin = useRef()
  // 登录或者支付
  const handleFun = () => {
    // window.gdt('track', 'RESERVATION', { key1: 'value1', key2: 'value2' })
    if (!getPhone()) {
      // 登录操作
      let result = loginRef.current.login()
      result.then((res) => {
        if (res !== 0 && res.code === 1) {
          setPhoneNum((phoneNum = !phoneNum))
          setUserPhone((userPhone = loginRef.current.phoneNumber))
          setMember_id(res.data.member_id)
          setKey(res.data.key)
          localStorage.setItem('member_id', res.data.member_id)
          sessionStorage.setItem('member_id', res.data.member_id)
          // 存储key
          sessionStorage.setItem('key', res.data.key)
          localStorage.setItem('key', res.data.key)
          // 存储手机
          storagUsertUserInfo({
            name: 'phone',
            value: userPhone,
          })
          localStorage.setItem('phone', userPhone)
          payed()
        } else {
          if (res == 'localStorage') {
            payed()
          } else {
            Toast.fail(res.message)
          }
        }
      })
    } else {
      payed()
    }
  }
  // 挽留页弹框
  const leave = () => {
    setModal2(false)
    poprs.onClose()
  }

  // 关闭
  const closePopup = () => {
    setModal2(true)
  }
  const payed = useCallback((num) => {
    let userMember =
      sessionStorage.getItem('member_id') || localStorage.getItem('member_id')
    goodsauthtwo(userMember).then((res) => {
      // res.code = -1 // 临时
      if (res.code == -110022 && !num) {
        // 支付
        childRef.current.payFun()
      }
      if (res.code === 1) {
        let memberId =
          sessionStorage.getItem('member_id') ||
          localStorage.getItem('member_id')
        window.location.hash = '#/result?member_id=' + memberId
      }
    })
  }, [])
  const enter = () => {
    setModal2(false)
  }
  useEffect(() => {
    if (getPhone()) {
      payed(1)
    }
  }, [payed])

  const changeVisible = (val) => {
    leave()
  }

  const changeSubFlag = (val) => {
    setSubFlag(val)
  }

  return (
    <Modal
      popup
      visible={poprs.visible}
      onClose={() => closePopup()}
      animationType="slide-up"
      afterClose={() => poprs.afterClose()}
      closable={true}
    >
      <p className={style.title}>
        支付剩余时间：
        <span className={style.fontRed}>{`${parseInt(countDown / 60)}分${
          countDown % 60
        }秒`}</span>
      </p>
      <div className={style.goodsInfo}>
        <div>
          <p className={style.goodsDetailsFrist}>证券学院•小牛学习营</p>
          <p className={style.goodsDetailsSecond}>
            10天实战名师带你边学边赚
          </p>
        </div>
        <div className={style.goodsDetails}>
          <span>¥{goodsPrice}</span>
        </div>
      </div>
      <div className={style.Login}>
        <Login
          Lref={loginRef}
          checked={checked}
          phoneNum={phoneNum}
          changeSubFlag={changeSubFlag}
          changeShowAgreement={poprs.changeShow}
        />
      </div>
      <OderInfo
        changeVisible={(val) => changeVisible(val)}
        cRef={childRef}
        member_id={member_id || getUserInfo('member_id')}
        key={key || getUserInfo('key')}
        checked={checked}
        checkedPay={checkedPay}
        checkeFun={(val) => setCheckedPay(val)}
        sku_id={poprs.sku_id}
      />
      <div className={style.bottomBnt}>
        <button
          disabled={!subFlag}
          className={style.payBtn}
          style={{ backgroundColor: `${!subFlag ? '#dcdcdc' : '#2064CA'}` }}
          onClick={() => {
            handleFun()
          }}
        >
          确认支付
        </button>
      </div>
      <Detainment
        onClose={() => setModal2(false)}
        visible={modal2}
        leave={() => leave()}
        enter={enter}
        sku_id={poprs.sku_id}
      />
    </Modal>
  )
}
